var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 4.71601C18.0007 4.59756 17.978 4.48014 17.9332 4.37049C17.8884 4.26084 17.8224 4.1611 17.739 4.07701L13.923 0.261015C13.8389 0.177601 13.7392 0.111609 13.6295 0.0668208C13.5199 0.0220327 13.4024 -0.00066976 13.284 1.50428e-05C13.1655 -0.00066976 13.0481 0.0220327 12.9385 0.0668208C12.8288 0.111609 12.7291 0.177601 12.645 0.261015L10.098 2.80801L0.261015 12.645C0.177601 12.7291 0.111609 12.8288 0.0668208 12.9385C0.0220327 13.0481 -0.00066976 13.1655 1.50428e-05 13.284V17.1C1.50428e-05 17.3387 0.094836 17.5676 0.263618 17.7364C0.432401 17.9052 0.661319 18 0.900013 18H4.71601C4.84194 18.0068 4.96791 17.9871 5.08574 17.9422C5.20358 17.8972 5.31065 17.828 5.40001 17.739L15.183 7.902L17.739 5.40001C17.8211 5.31278 17.8881 5.21238 17.937 5.10301C17.9457 5.03127 17.9457 4.95875 17.937 4.88701C17.9412 4.84511 17.9412 4.8029 17.937 4.76101L18 4.71601ZM4.34701 16.2H1.80001V13.653L10.737 4.71601L13.284 7.263L4.34701 16.2ZM14.553 5.994L12.006 3.44701L13.284 2.17801L15.822 4.71601L14.553 5.994Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.c28a7bb7ac4c0c4d254506095cf5e19f.svg";
export { ForwardRef as ReactComponent };